import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./lib/auth";
import AppLayout from "./components/AppLayout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Mitarbeiter from "./pages/Mitarbeiter";
import Fahrzeuge from "./pages/Fahrzeuge";
import FTTouren from "./pages/FTTouren";
import Tagestouren from "./pages/Tagestouren";
import TagestourenAbgleich from "./pages/TagestourenAbgleich";
import VerladungEntladung from "./pages/VerladungEntladung";
import Quickmail from "./pages/Quickmail";
import Aldi from "./pages/Aldi";
import Spedition from "./pages/Spedition";
import EPK from "./pages/EPK";
import Expenses from "./pages/Expenses";
import Monatsabschluss from "./pages/Monatsabschluss";
import Fahrerloehne from "./pages/Fahrerloehne";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-neutral-500" data-testid="auth-loading">
        Lade…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <AppLayout />
              </Protected>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/mitarbeiter" element={<Mitarbeiter />} />
            <Route path="/fahrzeuge" element={<Fahrzeuge />} />
            <Route path="/ft-touren" element={<FTTouren />} />
            <Route path="/tagestouren" element={<Tagestouren />} />
            <Route path="/tagestouren-abgleich" element={<TagestourenAbgleich />} />
            <Route path="/verladung-entladung" element={<VerladungEntladung />} />
            <Route path="/quickmail" element={<Quickmail />} />
            <Route path="/aldi" element={<Aldi />} />
            <Route path="/spedition" element={<Spedition />} />
            <Route path="/epk" element={<EPK />} />
            <Route path="/sonstige-kosten" element={<Expenses />} />
            <Route path="/fahrerloehne" element={<Fahrerloehne />} />
            <Route path="/monatsabschluss" element={<Monatsabschluss />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
